﻿import Swiper, { Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

document.addEventListener('DOMContentLoaded', () => {
    const $caseSliders = document.querySelectorAll('.swiper--case');

    $caseSliders.forEach($slider => {
        let $next = $slider.querySelector('.swiper-button-next');
        let $prev = $slider.querySelector('.swiper-button-prev');
        let $pagination = $slider.querySelector('.swiper-pagination');

        new Swiper($slider, {
            slidesPerView: '1',
            spaceBetween: 24,
            navigation: {
                nextEl: $next,
                prevEl: $prev
            },
            pagination: {
                el: $pagination,
                clickable: true
            },
        });
    });
});
